// extracted by mini-css-extract-plugin
module.exports =  {"information":"information__t7SJJ"};